import React from 'react';

export const MissingPage = () => (
  <svg
    fill="none"
    height="52"
    viewBox="0 0 52 52"
    width="52"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      height="32.5"
      rx="4.33333"
      stroke="black"
      strokeWidth="3.25"
      width="36.8333"
      x="6.5"
      y="8.66699"
    />
    <line
      stroke="black"
      strokeWidth="3.25"
      x1="7"
      x2="44"
      y1="17.375"
      y2="17.375"
    />
    <circle cx="12" cy="13" fill="black" r="1" />
    <circle cx="16" cy="13" fill="black" r="1" />
    <circle cx="20" cy="13" fill="black" r="1" />
    <line
      stroke="black"
      strokeWidth="1.5"
      x1="20.8638"
      x2="28.9811"
      y1="25.4355"
      y2="33.5528"
    />
    <path
      d="M28.8096 25.6074L20.6923 33.7247"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
